import React from "react";
import { Button, Card, Input } from "reactstrap";
import { BASE_URL } from "../../constants";
import PasswordStrengthInstruction from "./PasswordStrengthInstruction";
import {Link} from 'react-router-dom';

const PasswordResetView = ({ handleFieldChange, resetPasswordData, saveLoading, handleSave }) => {
  return (
    <React.Fragment>
      <h4 style={{ marginBottom: "24px" }}>Reset Your Password</h4>
      <Card
        style={{
          padding: "20px",
          width: "100%",
          maxWidth: "600px",
          borderRadius: "6px",
        }}
      >
        {resetPasswordData.expiredToken ? (
          <h6>
            The link has expired. Click {<u><Link to={`${BASE_URL}/forgotpassword`}>here</Link></u>} to generate a new link.
          </h6>
        ) : (
          <React.Fragment>
            <h6>
              Change your password - To create a safe password, please make sure
              you use;
            </h6>
            <PasswordStrengthInstruction
              passwordStrength={3}
              customClassName="font-weight-semibold font-sm"
            />
            <div className="mt-1">
              <label className="form-control-label" htmlFor="name">
                New Password
              </label>
            </div>
            <div>
              <Input
                type="password"
                onChange={(e) =>
                  handleFieldChange({ value: e, field: "newPassword" })
                }
                name="newPassword"
                style={{ marginBottom: "24px" }}
              />
            </div>
            <div>
              <label className="form-control-label" htmlFor="name">
                Confirm Password
              </label>
            </div>
            <div>
              <Input
                type="password"
                onChange={(e) =>
                  handleFieldChange({ value: e, field: "confirmNewPassword" })
                }
                name="confirmNewPassword"
                style={{ marginBottom: "24px" }}
              />
            </div>
            <Button
              color="success"
              onClick={handleSave}
              style={{
                width: "100%",
                fontWeight: "600",
                padding: "14px 0",
                cursor: "pointer",
              }}
              className={saveLoading ? "no-pointer-events" : ""}
            >
              SAVE & UPDATE
            </Button>
          </React.Fragment>
        )}
      </Card>
    </React.Fragment>
  );
};
export default PasswordResetView;
